import {useParams} from "react-router-dom";
import {SpaceComponent} from "../../components/3d/space";
import { ButtonContainer } from "../../components/organisms/ButtonContainer";
import { Instructions } from "../../components/organisms/Instructions";

export const MuseumSpace = () => {
  const {space} = useParams();
  return (
      <div>
        <div className={space === "hexa" ? "col-md-9" : ""}>
          <SpaceComponent/>
          <ButtonContainer showFeedback />
          <Instructions />
        </div>
      </div>
  );
};
